import {ref} from "vue";

export default function useFilterControls() {

    const filtersOpened = ref(false)

    const toggleMobileFilters = (val) => {
        if (typeof val === "undefined")
            return filtersOpened.value = !filtersOpened.value

        filtersOpened.value = Boolean(val)
    }

    return {
        toggleMobileFilters,
        filtersOpened
    }
}